import { ReactNode } from 'react';

import { BookmarkButton } from '@ui/components/BookmarkButton';
import { BookmarkButtonBar } from '@ui/components/BookmarkButtonBar';
import { Loader } from '@ui/components/Loader';
import { CreateIcon } from '@ui/icons/CreateIcon';
import { EditIcon } from '@ui/icons/EditIcon';

import { ClubSubHeader } from '@features/club/ui/ClubSubHeader/ClubSubHeader';
import { MemberClubDto } from '@features/shared/api/typings';

import styles from './ClubCardPage.module.css';

export type Props = {
  club?: MemberClubDto;
  isPending: boolean;
  isManager: boolean;
  isAdmin: boolean;
  members?: ReactNode;
  events?: (className: string) => ReactNode;
  myStats?: ReactNode;
  onSettings: () => void;
  onTournamentCreate: () => void;
  onMatchCreate: () => void;
  participationButton?: ReactNode;
};
export function ClubCardPage({
  club,
  isPending,
  isManager,
  isAdmin,
  members,
  events,
  myStats,
  onTournamentCreate,
  onMatchCreate,
  onSettings,
  participationButton,
}: Props) {
  return (
    <>
      {isPending && <Loader centered />}

      {!isPending && (
        <>
          <ClubSubHeader club={club} actions={participationButton} />

          {events?.(styles.events)}

          {members}

          {myStats}
        </>
      )}

      {(isManager || isAdmin) && (
        <BookmarkButtonBar>
          <BookmarkButton icon={<EditIcon />} label="Настройки" onClick={onSettings} />
          {
            isManager && (
              <BookmarkButton
                icon={<CreateIcon />}
                label="Создать"
                clickedStateTop={
                  <div className={styles.bookmarkSubButton} onClick={onTournamentCreate}>
                    Турнир
                  </div>
                }
                clickedStateBottom={
                  <div className={styles.bookmarkSubButton} onClick={onMatchCreate}>
                    Матч
                  </div>
                }
              />
            )
          }
        </BookmarkButtonBar>
      )}
    </>
  );
}
